import React, { useMemo } from 'react';

import Avatar from '@atlaskit/avatar';
import { Flex } from '@atlaskit/primitives';
import { useResponderNames } from '@atlassian/eoc-responder-names';

export const Team = ({ ownerTeamId }: { ownerTeamId: string }) => {
	const requestedResponders = useMemo(() => {
		if (ownerTeamId) {
			return [{ id: ownerTeamId, type: 'team' } as const];
		}
		return [];
	}, [ownerTeamId]);

	const [team] = useResponderNames(requestedResponders);

	return (
		<>
			{'name' in team && (
				<Flex alignItems="center" columnGap="space.050">
					<Avatar borderColor="transparent" size="small" src={team.avatarUrl} />
					<div>{team.name}</div>
				</Flex>
			)}
		</>
	);
};
